import { render, staticRenderFns } from "./CourseSchedule.vue?vue&type=template&id=ddc91336&scoped=true&"
import script from "./CourseSchedule.vue?vue&type=script&lang=js&"
export * from "./CourseSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CourseSchedule.vue?vue&type=style&index=0&id=ddc91336&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc91336",
  null
  
)

export default component.exports